import type { TourDefinition } from '../../../models/tour.interfaces';

export const reservationsTour: TourDefinition = {
  module: 'reservations',
  steps: [
    {
      id: 'reservas_step_1',
      order: 1,
      target: '[data-testid="btn-add-reservation"]',
      title: 'Crea una nueva reserva',
      body: 'Haz clic aquí para registrar una reserva en tu agenda.',
      requiredAction: 'click',
      nextStepTrigger: 'onElementClick',
      placement: 'bottom',
      skippable: true,
    },
    {
      id: 'reservas_step_2',
      order: 2,
      target: '[data-testid="reservation-date"]',
      title: 'Selecciona la fecha',
      body: 'Elige el día en el que se realizará la reserva.',
      requiredAction: 'select',
      nextStepTrigger: 'onNextButton',
      placement: 'right',
      skippable: false,
    },
    {
      id: 'reservas_step_3',
      order: 3,
      target: '[data-testid="reservation-client"]',
      title: 'Elige un cliente',
      body: 'Busca un cliente existente en el buscador o haz clic en "+ Nuevo cliente" para crear uno nuevo.',
      requiredAction: 'select_or_create',
      nextStepTrigger: 'onTargetDisappear',
      placement: 'right',
      spotlightExtraHeight: 250,
      skippable: false,
    },
    {
      id: 'reservas_step_4',
      order: 4,
      target: '[data-testid="reservation-service"]',
      title: 'Elige un servicio',
      body: 'Escribe el nombre del servicio y escógelo de la lista desplegable.',
      requiredAction: 'select',
      nextStepTrigger: 'onNextButton',
      placement: 'left',
      spotlightExtraHeight: 200,
      skippable: false,
    },
    {
      id: 'reservas_step_5',
      order: 5,
      target: '[data-testid="reservation-employee"]',
      title: 'Asigna un empleado',
      body: 'Selecciona al colaborador que atenderá este servicio.',
      requiredAction: 'select',
      nextStepTrigger: 'onNextButton',
      placement: 'left',
      skippable: false,
    },
    {
      id: 'reservas_step_6',
      order: 6,
      target: '[data-testid="reservation-time"]',
      title: 'Indica el horario',
      body: 'Elige la hora a la que se realizará el servicio.',
      requiredAction: 'select',
      nextStepTrigger: 'onNextButton',
      placement: 'left',
      skippable: false,
    },
    {
      id: 'reservas_step_7',
      order: 7,
      target: '[data-testid="reservation-add-service"]',
      title: 'Agregar más servicios',
      body: 'Puedes añadir un segundo o tercer servicio dentro de la misma reserva.',
      requiredAction: 'click_optional',
      nextStepTrigger: 'onNextButton',
      placement: 'bottom',
      skippable: true,
    },
    {
      id: 'reservas_step_8',
      order: 8,
      target: '[data-testid="btn-save-reservation"]',
      title: 'Guardar reserva',
      body: 'El botón se habilita al completar fecha, cliente, servicio, empleado y hora.',
      requiredAction: 'click',
      nextStepTrigger: 'onElementClick',
      placement: 'bottom',
      skippable: false,
    },
    {
      id: 'reservas_step_9',
      order: 9,
      target: '[data-testid="calendar-reservation"]',
      title: 'Reserva registrada',
      body: 'Aquí verás la nueva reserva reflejada en el calendario semanal.',
      requiredAction: 'none',
      nextStepTrigger: 'onFinish',
      placement: 'top',
      skippable: true,
    },
  ],
};
